export const kassimBlue = '#004a6d';
export const kassimGreen = '#34b233';

export const orange = '#ff5e00';
export const backgroundGrey = '#aaa';

export const headerHeight = 70;

export const makeTransparent = (color, transparency) => {
    // if color format = #rrggbb:
    const tVal =
        transparency <= 1 ? Math.round(transparency * 255) : transparency;
    const tStr = tVal.toString(16);
    return `${color}${tStr}`;
};
